import authApi from 'api/auth';
import { useAppTranslation } from 'app/hooks';
import React, { useState, useEffect } from 'react';

interface CountDownTimerProps {
  isOpen: boolean;
  email: string;
}

const MINUTES = 3;
const SECOND_ON_MINUTE = 60;

const CountDownTimer: React.FunctionComponent<CountDownTimerProps> = ({ isOpen, email }) => {
  const t = useAppTranslation();
  const [timeRemaining, setTimeRemaining] = useState(SECOND_ON_MINUTE * MINUTES);

  const sendOtp = async () => {
    const { ok } = await authApi.forgotPassword({
      email: email,
    });
    if (ok) {
      setTimeRemaining(SECOND_ON_MINUTE * MINUTES);
    }
  };

  useEffect(() => {
    let timerInterval: NodeJS.Timeout;

    if (isOpen) {
      timerInterval = setInterval(() => {
        setTimeRemaining((prevTime) => {
          if (prevTime <= 0) {
            clearInterval(timerInterval);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [isOpen, timeRemaining]);

  useEffect(() => {
    if (isOpen) {
      setTimeRemaining(SECOND_ON_MINUTE * MINUTES);
    }
  }, [isOpen]);

  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;

  return (
    <div className="font-medium primary-text-color timmer">
      <p>
        {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
      </p>
      {timeRemaining === 0 && (
        <button type="button" className="sendOtpButton" onClick={sendOtp}>
          {t('resetPassword.sendOtpAgain')}
        </button>
      )}
    </div>
  );
};

export default CountDownTimer;
